/* eslint-disable indent */
class Payment {
  constructor() {
    this.stage = 'prod';
    this.parameter = {};
  }

  setConfig({stage, parameter}) {
    if (stage != null) {
      this.stage = stage;
    }
    if (parameter != null) {
      this.parameter = parameter;
    }
  }

  get URL() {
    return this.stage === 'prod'
      ? {
          CREATE_ORDER: 'https://www.paynow.com.tw/service/etopm.aspx',
        }
      : {
          CREATE_ORDER: 'https://test.paynow.com.tw/service/etopm.aspx',
        };
  }

  /**
   * [Public] 創建訂單後續動作 - 跳轉至 Paynow 支付頁進行支付
   * @param {Object} data 傳給 paynow 的訂單資料
   */
  followUp(data) {
    const id = 'paynow-form';

    let formElement = document.getElementById(id);
    if (!formElement) {
      formElement = document.createElement('form');
      formElement.id = id;
    }
    formElement.innerHTML = '';
    formElement.method = 'POST';
    formElement.action = this.URL.CREATE_ORDER;
    formElement.style.display = 'none';

    Object.keys(data).map((key) => {
      const inputElement = document.createElement('input');
      inputElement.name = key;
      inputElement.value = data[key];
      inputElement.type = 'hidden';

      formElement.appendChild(inputElement);
    });
    document.body.appendChild(formElement);

    formElement.submit();
  }
}

export default new Payment();
